export default function Zakres(props) {
	return <span id="a11y-zakres">{props.children}</span>;
}
